import { reducer as FormReducer } from 'redux-form/immutable';
// import { fromJS } from 'immutable';
import { combineImmutableReducers } from './util';
import SessionReducer, * as SessionSelect from './session/reducer';
import ExampleAppReducer, * as ExampleAppSelectors from './example_app/reducer';
import GlobalSettingsReducer, * as GlobalSettingsSelectors from './global_settings/reducer';
import ACTIONS from './actions';
import HubSpotFormReducer, { getContactFormStatus, getContactFormErrorMessage } from './hub_spot_form/reducer';
import { ContentReducer, ContentSelectors } from './vendor/flamelink';

export const ModalReducer = (state = false, action) => {
  switch (action.type) {
  case ACTIONS.SHOW_MODAL:
    return action.modal;
  case ACTIONS.HIDE_MODAL:
    return false;
  default:
    return state;
  }
};

const Reducer = combineImmutableReducers({
  content: ContentReducer,
  form: FormReducer,
  session: SessionReducer,
  exampleApp: ExampleAppReducer,
  globalSettings: GlobalSettingsReducer,
  hubSpotForm: HubSpotFormReducer,
  modal: ModalReducer,
});

export default Reducer;

// Flamelink Content
export const getPages = state => ContentSelectors.getPages(state.get('content'));
export const getPageByTitle = (state, title) => ContentSelectors.getPageByTitle(state.get('content'), title);
export const getSnippets = state => ContentSelectors.getSnippets(state.get('content'));
export const getSnippetByTitle = (state, title) => ContentSelectors.getSnippetByTitle(state.get('content'), title);
export const getSnippetBySlug = (state, slug) => ContentSelectors.getSnippetBySlug(state.get('content'), slug);

export const getFaqs = state => ContentSelectors.getFaqs(state.get('content'));
export const getFaqByTitle = (state, title) => ContentSelectors.getFaqByTitle(state.get('content'), title);

// HubSpot Selectors
export const getHubSpotContactFormStatus = state => getContactFormStatus(state.get('hubSpotForm'));
export const getHubSpotContactFormErrorMessage = state => getContactFormErrorMessage(state.get('hubSpotForm'));

export const getExampleAppFormStatus = state => ExampleAppSelectors.getFormStatus(state.exampleApp);
export const getWidgets = state => ExampleAppSelectors.getWidgets(state.exampleApp);
export const getGlobalSetting = (state, key, notSetValue = undefined) => GlobalSettingsSelectors.getSetting(state.globalSettings, key, notSetValue);
export const getFlashList = state => SessionSelect.getFlashList(state.session);
export const getCurrentUser = state => SessionSelect.getCurrentUser(state.session);

export const getModal = state => state.get('modal');



// WEBPACK FOOTER //
// ./src/reducer.js